/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getModelConceptPrice } from '../fn/pricing/get-model-concept-price';
import { GetModelConceptPrice$Params } from '../fn/pricing/get-model-concept-price';
import { getProductItemPrice } from '../fn/pricing/get-product-item-price';
import { GetProductItemPrice$Params } from '../fn/pricing/get-product-item-price';
import { getSoftwareProductPrice } from '../fn/pricing/get-software-product-price';
import { GetSoftwareProductPrice$Params } from '../fn/pricing/get-software-product-price';
import { PricingDto } from '../models/pricing-dto';


/**
 * Pricing API
 */
@Injectable({ providedIn: 'root' })
export class PricingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSoftwareProductPrice()` */
  static readonly GetSoftwareProductPricePath = '/api/pricing/softwareProduct';

  /**
   * Get price for a SoftwareProduct.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSoftwareProductPrice()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSoftwareProductPrice$Response(params?: GetSoftwareProductPrice$Params, context?: HttpContext): Observable<StrictHttpResponse<PricingDto>> {
    return getSoftwareProductPrice(this.http, this.rootUrl, params, context);
  }

  /**
   * Get price for a SoftwareProduct.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSoftwareProductPrice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSoftwareProductPrice(params?: GetSoftwareProductPrice$Params, context?: HttpContext): Observable<PricingDto> {
    return this.getSoftwareProductPrice$Response(params, context).pipe(
      map((r: StrictHttpResponse<PricingDto>): PricingDto => r.body)
    );
  }

  /** Path part for operation `getProductItemPrice()` */
  static readonly GetProductItemPricePath = '/api/pricing/productItem';

  /**
   * Get price for a ProductItem.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductItemPrice()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductItemPrice$Response(params?: GetProductItemPrice$Params, context?: HttpContext): Observable<StrictHttpResponse<PricingDto>> {
    return getProductItemPrice(this.http, this.rootUrl, params, context);
  }

  /**
   * Get price for a ProductItem.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductItemPrice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductItemPrice(params?: GetProductItemPrice$Params, context?: HttpContext): Observable<PricingDto> {
    return this.getProductItemPrice$Response(params, context).pipe(
      map((r: StrictHttpResponse<PricingDto>): PricingDto => r.body)
    );
  }

  /** Path part for operation `getModelConceptPrice()` */
  static readonly GetModelConceptPricePath = '/api/pricing/modelConcept';

  /**
   * Get price for a ModelConcept.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getModelConceptPrice()` instead.
   *
   * This method doesn't expect any request body.
   */
  getModelConceptPrice$Response(params?: GetModelConceptPrice$Params, context?: HttpContext): Observable<StrictHttpResponse<PricingDto>> {
    return getModelConceptPrice(this.http, this.rootUrl, params, context);
  }

  /**
   * Get price for a ModelConcept.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getModelConceptPrice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getModelConceptPrice(params?: GetModelConceptPrice$Params, context?: HttpContext): Observable<PricingDto> {
    return this.getModelConceptPrice$Response(params, context).pipe(
      map((r: StrictHttpResponse<PricingDto>): PricingDto => r.body)
    );
  }

}
